import { supOrgDashboardSlotBookings } from '../../api/supportAdmin';

export const fetchSlotBookings = async (type, orgId, datesId, slotId, setDateDetails, setSlotDetails) => {
    const slotBookings = await supOrgDashboardSlotBookings(type, orgId, datesId, slotId);
    setDateDetails(slotBookings.data.data);
    setSlotDetails(slotBookings.data.slot);
    return;
};
